import react from "react";
import Request from "../../../../../api/Requests";
import axios from 'axios';


const postTable = (params) => {
    return Request('venues/table-form-save', 'POST', params, true);
}

const getTable = (params) => {
    return Request('venues/table-form-info', 'GET', params, true);
}

const getTables = (params) => {
    return Request('venues/table-list', 'GET', params, true);
}

const saveFloorImage = async (params) => {
    var response = null;
    const formData = new FormData();
    formData.append("image", params.image);
    formData.append("id_venues", params.id_venues);
    let token = localStorage.getItem("token-api");
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    await axios.post(process.env.REACT_APP_API_URL+'/index.php?r=venues/table-form-floor-image', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }).then((dataResponse) => {
        response = dataResponse
    }).catch((error) => {
        if (error.response.status === 401) {
            localStorage.removeItem('token-api');
        }
    });
    if (response.status === 200) {
        return response.data;
    } else {
        return null;
    }
}

const getFloorImage = (params) => {
    return Request('venues/table-get-floor-image', 'GET', params, true);
}


const savePaymentDetails = (params) => {
    return Request('venues/table-payments-form-save', 'POST', params, true);
}

const infoPaymentDetails = (params) => {
    return Request('venues/table-payments-form-info', 'GET', params, true);
}

const getTableTransactionsList = (params) => {
    return Request('venues/table-payments-transactions-list', 'GET', params, true);
}


const requestPaymentWithdrawal = (params) => {
    return Request('venues/table-payments-request-withdrawal', 'POST', params, true);
}


const acceptTerms = (params) => {
    return Request('venues/table-accept-terms', 'POST', params, true);
}

const saveTermsVenues = (params) => {
    return Request('venues/table-save-terms-venues', 'POST', params, true);
}

const getVenueTerms = (params) => {
    return Request('venues/table-get-terms-venues', 'GET', params, true);
}


export default {
    postTable,
    getTable,
    getTables,
    saveFloorImage,
    getFloorImage,
    savePaymentDetails,
    infoPaymentDetails,
    getTableTransactionsList,
    requestPaymentWithdrawal,
    acceptTerms,
    saveTermsVenues,
    getVenueTerms
}